import React from 'react';
import { ObjectWrapper } from './styles/Common.styles';
import {
  RankingWrapper,
  RankingButton,
  RankingList,
  RankingItem
} from './styles/Ranking.styles';

const RankingControl = ({ control }) => (
  <ObjectWrapper>
    <RankingWrapper styleProps={control.attributes}>
      <RankingButton styleProps={control.attributes}>UP</RankingButton>
      <RankingList styleProps={control.attributes}>
        {control.items.map((item, index) => (
          <RankingItem key={index} styleProps={control.attributes}>
            {item}
          </RankingItem>
        ))}
      </RankingList>
      <RankingButton styleProps={control.attributes}>DOWN</RankingButton>
    </RankingWrapper>
  </ObjectWrapper>
);

export default RankingControl;